angular.module("impactx.z").service("AngularRouterMigrationService", [
    "$route",
    "$redirect",
    function ($route, $redirect) {
        // Mit $routeParams hat es nicht funktioniert.

        this.hasLoadedServices = function () {
            return true;
        };

        this.getCurrentRouteOriginalPath = function () {
            return $route.current.$$route.originalPath;
        };

        function getCurrentParams() {
            var current = $route.current;
            if (
                current &&
                typeof current === "object" &&
                typeof current.params === "object"
            ) {
                return current.params;
            }
            return {};
        }

        this.getParams = function () {
            return getCurrentParams();
        };

        this.redirectTo = function (param1, url, parameters) {
            return $redirect.redirectTo(param1, url, parameters);
        };

        this.getLastParameters = function () {
            return $redirect.getLastParameters();
        };

        this.reload = function () {
            return $route.reload();
        };
    },
]);
